import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Salad, Copy } from 'lucide-react';
import { getApiUrl } from '../../utils/api';

const API_URL = getApiUrl();

// LMS V78 — diet-plan payments (₹199 = also a trial price) that OPS read as trials since 21 Oct.
const DietTrialRepairCard = () => {
  const [running, setRunning] = useState(null);
  const [result, setResult] = useState(null);

  const run = async (apply) => {
    if (apply && !window.confirm('Mark these as Diet Plan payments and undo the trial status they created?\n\nOnly leads with no genuine trial payment are changed. Safe to re-run.')) return;
    setRunning(apply ? 'apply' : 'dry');
    try {
      const res = await axios.post(`${API_URL}/api/data-repair/diet-payments-misread-as-trial`, { apply }, { withCredentials: true, timeout: 120000 });
      setResult(res.data);
      toast[apply ? 'success' : 'info'](`${apply ? 'Fixed' : 'Dry-run · found'} ${res.data.count} diet payment(s)`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Diet repair failed');
    } finally {
      setRunning(null);
    }
  };

  const copyForLms = () => {
    const rows = (result?.affected || []).map((r) => [r.email, r.name, r.payment_reference, r.order_id, `${r.currency} ${r.amount}`, r.ops_sent_trial_paid_to_lms ? 'trial_paid sent' : ''].join(' | '));
    navigator.clipboard.writeText(['email | name | payment | order | amount | note', ...rows].join('\n'));
    toast.success('List copied — paste it to the LMS team');
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5 space-y-3" data-testid="diet-trial-repair-card">
      <div className="flex items-center gap-2">
        <Salad className="w-4 h-4 text-emerald-600" />
        <h3 className="font-semibold text-slate-900">Diet payments read as trials (since 21 Oct)</h3>
      </div>
      <p className="text-xs text-slate-500">Finds ₹199 Diet Plan payments that OPS treated as trial payments, marks them as Diet Plan payments and undoes the trial status. Run the dry-run first.</p>
      <div className="flex gap-2">
        <button onClick={() => run(false)} disabled={!!running} className="btn-secondary text-sm" data-testid="diet-repair-dryrun-btn">{running === 'dry' ? 'Checking…' : 'Dry-run'}</button>
        <button onClick={() => run(true)} disabled={!!running} className="btn-primary text-sm" data-testid="diet-repair-apply-btn">{running === 'apply' ? 'Fixing…' : 'Fix now'}</button>
        {result?.count > 0 && (
          <button onClick={copyForLms} className="btn-secondary text-sm inline-flex items-center gap-1" data-testid="diet-repair-copy-btn"><Copy className="w-3.5 h-3.5" /> Copy list for LMS</button>
        )}
      </div>
      {result && (
        <div className="text-xs space-y-1" data-testid="diet-repair-result">
          <p className="font-medium text-slate-700">{result.applied ? 'Fixed' : 'Would fix'} {result.count} payment(s)</p>
          {(result.affected || []).map((r) => (
            <div key={r.payment_reference || r.order_id} className="border border-slate-100 rounded-md p-2">
              <p className="text-slate-800">{r.name || '—'} · {r.email || 'no email'} · {r.currency} {r.amount} · {r.payment_reference}</p>
              <p className="text-slate-500">{r.changes.join(' · ')}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DietTrialRepairCard;
